import dynamic from 'next/dynamic'
import { useQuizEntryExpInModal } from '../hooks'

/**
 * Optimizes bundle size by only importing and rendering the QuizEntryModal only when the user is in a variant condition
 * of the pen-5646_v1 experiment (variant_1 or variant_2). For users in the control group, this component returns null
 * and prevents the QuizEntryModal code from being downloaded.
 */
export const QuizEntryModalLoader = () => {
  const { isQuizEntryVariant } = useQuizEntryExpInModal()

  if (!isQuizEntryVariant) return null

  const QuizEntryModal = dynamic(
    () =>
      import('./QuizEntryModal').then((mod) => ({
        default: mod.QuizEntryModal,
      })),
    {
      ssr: false,
    },
  )

  return <QuizEntryModal />
}
